import React from 'react';
import {
  Radio as ChakraRadio,
  RadioProps as ChakraRadioProps,
  forwardRef,
} from '@chakra-ui/react';
import {
  ColorMode,
  useColorMode,
} from '@allergan-data-labs/alle-elements-core';
export interface RadioProps extends ChakraRadioProps {
  /** The surface color that the Radio is displayed over */
  colorMode?: ColorMode;
  isChecked?: boolean;
  isDisabled?: boolean;
}

/**
 * Radios are used when only one choice may be selected in a series of options.
 */
export const Radio = forwardRef<RadioProps, 'input'>((props, ref) => {
  const { children, colorMode: propColorMode, ...otherProps } = props;

  const { colorMode } = useColorMode(propColorMode);

  /* 
      The colorScheme value is populated by the colorMode prop. Had to do it
      this way because we cannot extend the chakra-ui component props and
      we kept getting an error for using custom props on a chakra component.
      Keep in mind that not all of our themed library components require
      this method. We also could not use the colorScheme property for our color
      mode changes because certain components, like button, was already using
      the colorScheme property.
    */
  const colorScheme = colorMode;
  return (
    <ChakraRadio ref={ref} colorScheme={colorScheme} {...otherProps}>
      {children}
    </ChakraRadio>
  );
});

export { RadioGroup } from '@chakra-ui/react';
